export const groupBy = (arr, key) =>
  // GroupBy set of objects with the given Key
  arr.reduce(
    (result, item) => ({
      ...result,
      [item[key]]: [...(result[item[key]] || []), item],
    }),
    {},
  );
